import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext(null);
export const useSettings = () => useContext(SettingsCtx);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => setCategories([]));
  }, []);

  const shopCategories = categories.filter((c) => c.show_in_shop !== false);
  const builderCategories = categories.filter((c) => c.show_in_builder !== false);
  return <SettingsCtx.Provider value={{ settings: settings || {}, categories, shopCategories, builderCategories }}>{children}</SettingsCtx.Provider>;
}
